<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <Breadcrumb
            :items="[{name: 'Home', url: '/dashboard'}]"
            :currentItem="i18n('Transações')"
          />
          <h1 class="max">{{i18n('Transações')}}</h1>
        </v-flex>
        <v-layout row wrap class="transactions-filter" pt-4 justify-space-between >
          <v-layout row wrap px-3>
            <v-flex class="date-filter" xs5 lg4 >
              <DefaultFilterDateTime
                ref="filterDateTimeFrom"
                kind="date"
                :callback="this.setFilterDateTimeFrom"
                :label="i18n('Data inicial')"
                @resetFilter="resetFilterDateTimeFrom()"
              />
            </v-flex>
            <v-flex class="date-filter" xs5 px-3 lg4>
              <DefaultFilterDateTime
                ref="filterDateTimeTo"
                kind="date"
                :callback="this.setFilterDateTimeTo"
                :label="i18n('Data final')"
                @resetFilter="resetFilterDateTimeTo()"
              />
            </v-flex>
            <v-flex xs5 md2 lg4>
              <v-select
                v-model="filterStatus"
                :items="filterStatusItems"
                label="Status"
                outline
                height="50"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-space-between px-3>
            <v-flex xs1 md1 lg2>
              <v-select
                v-model="filterOperationCurrency"
                :items="filterOperationCurrencyItems"
                :label="i18n('De')"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs5 md1 lg2 pl-3>
              <v-select
                v-model="filterOperationExchangeCurrency"
                :items="filterOperationCurrencyItems"
                :label="i18n('Para')"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs2 md2 lg3 pl-3>
              <v-text-field
                v-model="filterId"
                box
                append-icon="manage_search"
                :placeholder="i18n('Pesquisar por ID')"
              ></v-text-field>
            </v-flex>
            <v-flex md2 px-1 lg3 px-3>
              <CompanySelect 
                :model="filterSubjectId"
                :label="i18n('Nº do Doc. Cliente')"
                search_mode="document_number_prefix"
                @onIdSelected="this.subjectIdSelected"
                @onCompanyList="this.subjectListSelected"
                ref="filterSubjectId"
              />
            </v-flex>
            <v-flex xs5 md3 lg2>
              <v-btn class="filter-btn" color="#27DABC" depressed dark @click="filter()">
                Filter
                <ion-icon name="funnel-outline"></ion-icon>
              </v-btn>
              <v-btn class="reload-filter-btn" flat icon color="white" @click="resetFilter()">
                <ion-icon name="reload-outline" size="large"></ion-icon>
              </v-btn>
              <div class="title-statement-child">
                <span @click="downloadCsv()" class="rounded-chip mr-3">{{i18n('Baixar %s').replace('%s', 'CSV')}}</span>
              </div>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-flex xs12 mt-3>
          <div v-if="loaded == 'not_loaded'">{{i18n('Carregando transações...')}}</div>
          <div v-if="loaded == 'error'">{{i18n('Algo errado. Não foi possível carregar as transações.')}}</div>
          <div v-if="loaded == 'not_authorized'">{{i18n('Não foi possível carregar as transações. Você não foi autorizado.')}}</div>
          <div v-if="loaded == 'transaction_id_error'">{{i18n('Não foi possível carregar a transação. Verifique o ID informado.')}}</div>
          <transition name="fade">
            <v-layout row wrap>
              <v-flex xs12 id="table-transactions">
                <DefaultDataTable
                  :headers="headers"
                  :items="records"
                  :loading="loading"
                  :no-data-text="i18n('Nenhuma transação registrada')"
                >
                  <template v-slot:items="props">
                    <tr @click.stop="rowClick(props.item, props.index)">
                      <td v-if="props.item.panel !== true" class="text-xs-left"><span>{{ insertedDate(props.item) }}</span> <span class="font-weight-light">{{ insertedTime(props.item) }}</span></td>
                      <td v-if="props.item.panel !== true" class="text-xs-left">
                        <span>{{ props.item.subject.social_name }}</span>
                        <br />
                        <span class="font-weight-light">{{ props.item.subject.document_type.toUpperCase()}} {{mask(props.item.subject.document_type, props.item.subject.document_number)}}</span>
                      </td>
                      <td v-if="props.item.panel !== true" class="text-xs-center">
                        <v-chip class="fixed-chip" :color="statusColorFor(props.item)" :text-color="textColorForChip(props.item)">{{ statusTextFor(props.item) }}</v-chip>
                      </td>
                      <td v-if="props.item.panel !== true" class="text-xs-center">{{ props.item.currency }}/{{ props.item.exchange_currency }}</td>
                      <td v-if="props.item.panel !== true" class="text-xs-right">{{sourceValue(props.item)}}
                        <v-icon v-if="isPendingReverseExchange(props.item)">update</v-icon>
                      </td>
                      <td v-if="props.item.panel !== true" class="text-xs-right">{{exchangeRate(props.item)}}</td>
                      <td v-if="props.item.panel !== true" class="text-xs-right">{{exchangedValue(props.item)}}</td>
                      <td v-if="props.item.panel === true" class="text-xs-center" colspan="8">{{props.item.subject.social_name}}</td>
                    </tr>
                  </template>
                </DefaultDataTable>
                <v-layout row wrap my-5>
                  <v-flex xs6 pr-2>
                    <v-btn class="btn-style ma-0 mr-2" block dark @click="loadPreviousPageRecords" v-show="hasPreviousPage"><v-icon left dark>skip_previous</v-icon> {{i18n('Mais Recentes')}}</v-btn>
                  </v-flex>
                  <v-flex xs6 pl-2>
                    <v-btn class="btn-style--secondary ma-0 mr-2" block dark @click="loadNextPageRecords" v-show="hasNextPage">{{i18n('Mais Antigas')}} <v-icon right dark>skip_next</v-icon></v-btn>
                  </v-flex>
                </v-layout>
                <details-dialog :addBtn="false" :record="selectedRecord" :hasPrevious.live="hasPrevious" :hasNext.live="hasNext" :dialog="dialog" @closeDialog="closeDialog" @loadPrevious="loadPrevious" @loadNext="loadNext"/>
              </v-flex>
            </v-layout>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import CustomerScheduledBankTransactionDetailsDialog from "./CustomerScheduledBankTransactionDetailsDialog"
import Breadcrumb from "./components/Breadcrumb"
import DefaultDataTable from "./components/DefaultDataTable"
import DefaultFilterDateTime from "./components/filters/DefaultFilterDateTime"
import CompanySelect from "./components/filters/CompanySelect"
import utils from "./shared/Utils"
import { getAllCurrenciesSelect } from "./shared/Currencies"
import statement from "./shared/Statement"

const all_currencies_select = getAllCurrenciesSelect()

let transactions_keyboard_listener

export default {
  name: 'CustomerScheduledBankTransactionList',
  components: {
    layout: LeftBarLayout,
    'details-dialog': CustomerScheduledBankTransactionDetailsDialog,
    Breadcrumb,
    DefaultDataTable,
    DefaultFilterDateTime,
    CompanySelect
  },
  data(vm) {
    return {
      records: [],
      loaded: 'not_loaded',
      loading: false,
      reload: false,
      selectedRecord: {},
      selectedIndex: 0,
      indexOffset: 0,
      filterSubjectId: null,
      filterId: null,
      filterStatus: "all",
      filterStatusItems: [
        {text: vm.i18n('Todas'), value: 'all'},
        {text: vm.i18n('Pendente'), value: 'pending'},
        {text: vm.i18n('Identificada'), value: 'identified'},
        {text: vm.i18n('Convertida'), value: 'exchanged'},
        {text: vm.i18n('Transferida'), value: 'wired'},
        {text: vm.i18n('Cancelada'), value: 'canceled'}
      ],
      filterDateTimeFrom: null,
      filterDateTimeTo: null,
      filterOperationCurrency: "all",
      filterOperationExchangeCurrency: "all",
      filterOperationCurrencyItems: [
        {text: vm.i18n('Todas'), value: 'all'},
        ...all_currencies_select
      ],
      dialog: false,
      last_id: null,
      previous_ids: [],
      headers: [
        { text: vm.i18n('Data'), value: 'bank_name', align: 'left', sortable: false },
        { text: vm.i18n('Nome/Documento'), value: 'name', align: 'left', sortable: false },
        { text: vm.i18n('Status'), value: 'status', align: 'center', sortable: false },
        { text: vm.i18n('Operação'), value: 'operation', align: 'center', sortable: false },
        { text: vm.i18n('Recebido'), value: 'value', align: 'right', sortable: false },
        { text: vm.i18n('Câmbio'), value: 'value', align: 'right', sortable: false },
        { text: vm.i18n('Enviado'), value: 'value_me', align: 'right', sortable: false }
      ],
      page_limit: 100,
      filterSubjectList: [],
      consolidateFilter: {
        filterDateTimeFrom: null,
        filterDateTimeTo: null,
        filterStatus: "all",
        filterOperationCurrency: "all",
        filterOperationExchangeCurrency: "all",
        filterId: null,
        filterSubjectId: null,
        filterSubjectList: []
      }
    }
  },
  computed: {
    filterContentsAlign () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'align-contents-center'
        case 'sm': return 'align-contents-center'
        case 'md': return 'align-contents-center'
        case 'lg': return 'align-contents-right'
        case 'xl': return 'align-contents-right'
      }
    },
    fontSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'caption'
        case 'sm': return 'body-1'
        case 'md': return 'body-1'
        case 'lg': return 'body-1'
        case 'xl': return 'body-1'
      }
    },
    hasPrevious() {
      return this.selectedIndex > 0
    },
    hasNext() {
      return this.selectedIndex < this.records.length - 1
    },
    hasPreviousPage() {
      return this.previous_ids.length > 0
    },
    hasNextPage() {
      return this.records.length == this.page_limit
    },
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadRecords()
    this.$root.$on('reload-transactions', (_new_transaction) => {
      this.loadRecords()
    })
  },
  created() {
    transactions_keyboard_listener = this.keyboardListener.bind(this)
    window.addEventListener('keydown', transactions_keyboard_listener, false)
  },
  destroyed() {
    window.removeEventListener('keydown', transactions_keyboard_listener, false);
  },
  methods: {
    subjectIdSelected(id) {
      this.filterSubjectId = id
    },
    subjectListSelected(subjectList) {
      this.filterSubjectList = subjectList
    },
    i18n(str) {
      return this.$root.l(str)
    },
    keyboardListener(e) {
      this.$nextTick(()=>{
        const focusElement = document.activeElement.tagName.toLowerCase()
        if (!this.dialog) {
          let key = e.which || e.keyCode
          if (key === 37 && focusElement !== "input") {
            this.loadPreviousPageRecords()
            return
          }

         if (key === 39 && focusElement !== "input") {
            this.loadNextPageRecords()
            return
          }
        }
      })
    },
    insertedDate(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[0]
    },
    insertedTime(record) {
      return utils.dbDateTimeToHuman(record.inserted_at).split(' ')[1]
    },
    operationColor(record) {
      return this.$root.isLocalCurrency(record.currency) ? 'buy-operation' : 'sell-operation'
    },
    rowClick(item, index) {
      this.$nextTick(()=>{
        this.selectedRecord = item
        this.selectedIndex = index
        this.dialog = true
      })
    },
    reloadRecords() {
      if (this.loading) {
        this.reload = true
      } else {
        this.reload = false
        this.previous_ids = []
        this.last_id = null
        this.loadRecords()
      }
    },
    loadRecords() {
      if (this.loading) return

      this.resetToConsolidateFilter();

      let successCallback = (response) => {
        if (response.body.data) {
          this.records = response.body.data
          if (this.records.length === 0) {
            this.loaded = 'empty'
          } else {
            this.loaded = 'ok'
          }
        } else {
          this.loaded = 'error'
        }
        this.loading = false
        if (this.reload) {
          this.reloadRecords()
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.loaded = 'not_authorized'
        } else if (response.body.error && response.body.error == "ID is not valid"){
            this.loaded = 'transaction_id_error'
        } else {
            this.loaded = 'error'
        }

        this.records = []
        this.loading = false

        if (this.reload) {
          this.reloadRecords()
        }
      }

      let token = this.$cookies.get('api_token')
      this.loading = true

      let params = {
        complete: 'true',
        status: this.filterStatus,
        last_id: this.last_id,
        per_page: this.page_limit
      }

      if (this.consolidateFilter.filterDateTimeFrom) {
        params.from = this.consolidateFilter.filterDateTimeFrom
      }
      if (this.consolidateFilter.filterDateTimeTo) {
        params.to = this.consolidateFilter.filterDateTimeTo
      }

      if (this.consolidateFilter.filterOperationCurrency != 'all') {
        params.currency = this.consolidateFilter.filterOperationCurrency
      }

      if (this.consolidateFilter.filterOperationExchangeCurrency != 'all') {
        params.exchange_currency = this.consolidateFilter.filterOperationExchangeCurrency
      }

      if (this.consolidateFilter.filterSubjectId) {
        params.subject_id = this.consolidateFilter.filterSubjectId
      }

      if (this.consolidateFilter.filterId && this.consolidateFilter.filterId.trim() !== '') {
        params.id = this.consolidateFilter.filterId.trim()
      }
      this.$http.get(this.$root.urls.customer__scheduled_bank_transactions, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadNextPageRecords() {
      if (this.hasNextPage) {
        this.previous_ids = this.previous_ids.concat(this.last_id)
        this.last_id = this.records[this.records.length - 1]['id']
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    loadPreviousPageRecords() {
      if (this.hasPreviousPage) {
        this.last_id = this.previous_ids.pop()
        this.loadRecords()
        this.moveScrollUp()
      }
    },
    moveScrollUp() {
      setTimeout(function(){
        this.$nextTick(function(){
          this.$vuetify.goTo('#table-transactions', {duration: 800, offset: 100, easing: 'easeInOutCubic'})
        })
      }.bind(this), 100)
    },
    resetToConsolidateFilter() {
      this.filterDateTimeFrom = this.consolidateFilter.filterDateTimeFrom
      this.$refs.filterDateTimeFrom.filterDate = this.getDateOrTimeFromDateTime(this.filterDateTimeFrom, "date")
      this.$refs.filterDateTimeFrom.filterTime = this.getDateOrTimeFromDateTime(this.filterDateTimeFrom, "time")

      this.filterDateTimeTo = this.consolidateFilter.filterDateTimeTo
      this.$refs.filterDateTimeTo.filterDate = this.getDateOrTimeFromDateTime(this.filterDateTimeTo, "date")
      this.$refs.filterDateTimeTo.filterTime = this.getDateOrTimeFromDateTime(this.filterDateTimeTo, "time")

      this.filterStatus = this.consolidateFilter.filterStatus
      this.filterOperationCurrency = this.consolidateFilter.filterOperationCurrency
      this.filterOperationExchangeCurrency = this.consolidateFilter.filterOperationExchangeCurrency
      this.filterId = this.consolidateFilter.filterId

      this.filterSubjectId = this.consolidateFilter.filterSubjectId
      this.$refs.filterSubjectId.selectedCompanyId = this.filterSubjectId
      this.filterSubjectList = this.consolidateFilter.filterSubjectList
      this.$refs.filterSubjectId.entries = this.consolidateFilter.filterSubjectList
      this.$refs.filterSubjectId.search = '';
    },
    getDateOrTimeFromDateTime(filter, type) {
      if (filter) {
        const date = new Date(`${filter}+03:00`);
        
        switch (type) {
          case "date":
            return date.toISOString().split("T")[0]
          case "time":
            return date.toISOString().slice(0, -8).split("T")[1]
          default:
            return
        }
      } else {
        return null
      }
    },
    mask(format, value) {
      return utils.mask(format, value)
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    isPendingReverseExchange(record) {
      return record.estimated_value_until_exchange && record.status == 'pending'
    },
    sourceValue(record) {
      if (this.isPendingReverseExchange(record)) return
      return this.l(record.value, record.currency)
    },
    exchangeRate(record) {
      if (record.bank_transaction && record.bank_transaction.exchange_approved) {
        return record.bank_transaction.exchange_rate
      } else {
        return 'N/A'
      }
    },
    exchangedValue(record) {
      if ((record.bank_transaction && record.bank_transaction.exchange_approved) || record.estimated_value_until_exchange) {
        return this.l(record.exchanged_value, record.exchange_currency)
      } else {
        return 'N/A'
      }
    },
    statusTextFor(record) {
      const status_map = {
        canceled: this.i18n('Cancelada'),
        pending: this.i18n('Pendente'),
        identified: this.i18n('Identificada'),
        exchanged: this.i18n('Convertida'),
        wired: this.i18n('Transferida')
      }
      return status_map[record.status]
    },
    statusHelpFor(record) {
      const status_help_map = {
        canceled: this.i18n('Transação cancelada'),
        pending: this.i18n('Aguardando pela identificação do transferência de entrada'),
        identified: this.i18n('Transferência de entrada identificada'),
        exchanged: this.i18n('Taxa de câmbio fechada'),
        wired: this.i18n('O valor convertido foi enviado')
      }
      return status_help_map[record.status]
    },
    statusColorFor(record) {
      const status_color_map = {
        canceled: 'rgba(96, 96, 96, 0.3)',
        pending: 'rgba(144, 140, 99, 0.3)',
        identified: 'rgba(46, 67, 105, 0.3)',
        exchanged: 'rgba(43, 122, 131, 0.2)',
        wired: 'rgba(7, 169, 124, 0.3)'
      }
      return status_color_map[record.status]
    },
    textColorForChip(record) {
      const status_chip_color_map = {
        canceled: '#6e6e6e',
        pending: '#908c63',
        identified: '#2e4369',
        exchanged: '#2b7a83de',
        wired: '#07a97c'
      }
      return status_chip_color_map[record.status]
    },
    closeDialog() {
      this.dialog = false
    },
    onCreate(record) {
      this.records.splice(0, 0, record)
    },
    loadPrevious() {
      this.selectedIndex = ((this.selectedIndex === 0) ? 0 : this.selectedIndex - 1 + this.indexOffset)
      this.selectedRecord = this.records[this.selectedIndex]
    },
    loadNext() {
      this.selectedIndex = ((this.selectedIndex === (this.records.length - 1)) ? this.selectedIndex : this.selectedIndex + 1 + this.indexOffset)
      this.selectedRecord = this.records[this.selectedIndex]
    },
    setFilterDateTimeFrom(filterDateTimeFrom) {
      this.filterDateTimeFrom = filterDateTimeFrom
    },
    setFilterDateTimeTo(filterDateTimeTo) {
      this.filterDateTimeTo = filterDateTimeTo
    },
    filter() {
      this.consolidateFilter.filterId = this.filterId
      this.consolidateFilter.filterStatus = this.filterStatus
      this.consolidateFilter.filterOperationCurrency = this.filterOperationCurrency
      this.consolidateFilter.filterOperationExchangeCurrency = this.filterOperationExchangeCurrency
      this.consolidateFilter.filterSubjectId = this.filterSubjectId
      this.consolidateFilter.filterDateTimeFrom = this.filterDateTimeFrom
      this.consolidateFilter.filterDateTimeTo = this.filterDateTimeTo
      this.consolidateFilter.filterSubjectList = this.filterSubjectList
      this.reloadRecords()
    },
    resetFilter() {
      this.filterDateTimeFrom = null;
      this.$refs.filterDateTimeFrom.filterDate = null
      this.$refs.filterDateTimeFrom.filterTime = null

      this.filterDateTimeTo = null;
      this.$refs.filterDateTimeTo.filterTime = null
      this.$refs.filterDateTimeTo.filterDate = null
      
      this.filterStatus = 'all'
      this.filterOperationCurrency = 'all'
      this.filterOperationExchangeCurrency = 'all'
      this.filterId = null

      this.filterSubjectId = null
      this.filterSubjectList = []
      this.$refs.filterSubjectId.search = null
      this.$refs.filterSubjectId.selectedCompanyId = null
      this.$refs.filterSubjectId.entries = null

      this.consolidateFilter = {
        filterDateTimeFrom: null,
        filterDateTimeTo: null,
        filterStatus: 'all',
        filterOperationCurrency: 'all',
        filterOperationExchangeCurrency: 'all',
        filterId: null,
        filterSubjectId: null,
        filterSubjectList: []
      }
      
      this.reloadRecords()
    },
    resetFilterDateTimeFrom() {
      this.filterDateTimeFrom = null;
      this.$refs.filterDateTimeFrom.filterDate = null
      this.$refs.filterDateTimeFrom.filterTime = null
    },
    resetFilterDateTimeTo() {
      this.filterDateTimeTo = null;
      this.$refs.filterDateTimeTo.filterDate = null
      this.$refs.filterDateTimeTo.filterTime = null
    },
    downloadCsv() {
      let recordStatementCVS = []
      if (this.hasNextPage || this.hasPreviousPage) {

        let successCallback = (response) => {
          if (response.body.data) {
            recordStatementCVS.push(...response.body.data);

            if (response.body.data.length == this.page_limit) {
              const params = this.downloadCsvParams(false, recordStatementCVS)
              this.$http.get(url, { params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
            } else {
              statement.exportAndDownloadTransactionsCsv(recordStatementCVS)
            }
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = this.$root.urls.customer__scheduled_bank_transactions
        const params = this.downloadCsvParams(true, null)

        this.$http.get(url, {params: params, headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      } else {
        statement.exportAndDownloadTransactionsCsv(this.records)
      }
    },
    downloadCsvParams(isFirstCall, recordStatementCVS) {
      let params = { status: this.filterStatus, per_page: this.page_limit }

      // When we have more than one page, we will call this function more than one time,
      // from the second time onwards, we need to get the last id from the list we have.
      if (!isFirstCall) {
        params.last_id = recordStatementCVS[recordStatementCVS.length - 1]['id']
      }

      if (this.consolidateFilter.filterDateTimeFrom) {
        params.from = utils.filterDateFrom(this.consolidateFilter.filterDateTimeFrom)
      }

      if (this.consolidateFilter.filterDateTimeTo) {
        params.to = utils.filterDateTo(this.consolidateFilter.filterDateTimeTo)
      }

      if (this.consolidateFilter.filterOperationCurrency != 'all') {
        params.currency = this.consolidateFilter.filterOperationCurrency
      }

      if (this.consolidateFilter.filterOperationExchangeCurrency != 'all') {
        params.exchange_currency = this.consolidateFilter.filterOperationExchangeCurrency
      }

      if (this.consolidateFilter.filterSubjectId) {
        params.subject_id = this.consolidateFilter.filterSubjectId
      }

      if (this.consolidateFilter.filterId) {
        params.id = this.consolidateFilter.filterId
      }

      return params
    },
    downloadEnabled() {
      return this.recordStatement.length > 0
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  .v-chip.fixed-chip {
    border-radius: 2px;
  }
  .visible-mark {
    width: 100px;
    height: 2px;
  }
  .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
    background-color: white!important;
  }
  .title-statement {
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
  }
  .title-statement-child {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/CustomerScheduledBankTransactionList.vue